import React from 'react'
import styles from './card.module.css'

export const CardBody = ({ classes, children }) => {
  return <div className={`${classes ? classes : ''} ${styles.cardBody}`}>{children}</div>
}
